import { h, Component } from "preact";

import find from "./images/find.svg";

class SearchInput extends Component {
  constructor(props) {
      super(props);
      this.onKeyUp = this.onKeyUp.bind(this);
  }

  onKeyUp(e) {
    e.stopPropagation();
    e.preventDefault();

    if( e.keyCode === 13) {
      this.props.onClick(e);
    }
  }

  render({ onChange, value = "", onClick }) {
    return (
      <div onSubmit={onClick} class="user-widget__search_input">
        <input
          type="text"
          class="user-widget__search_input__input"
          placeholder="Search by name..."
          onInput={onChange}
          value={value}
          onClick={e => e.stopPropagation()}
          onkeyup={this.onKeyUp}
        />
        <button class="user-widget__search_input__button" onClick={onClick}>
          <img
            src={find}
            alt="search"
          />
        </button>
      </div>
    );
  }
}

export default SearchInput;



// WEBPACK FOOTER //
// ./src/SearchInput.js